import { Box, Typography } from '@mui/material';
import { authScreen } from './authScreenStyles';

type Props = {
  children: React.ReactNode;
  icon: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  type?: 'button' | 'submit';
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
  tone?: 'dark' | 'marketing';
};

export default function AuthSocialButton({
  children,
  icon,
  onClick,
  disabled,
  type = 'button',
  buttonProps,
  tone = 'dark',
}: Props) {
  const marketing = tone === 'marketing';
  const mergedDisabled = disabled || buttonProps?.disabled;

  return (
    <Box
      component="button"
      type={type}
      {...buttonProps}
      disabled={mergedDisabled}
      onClick={onClick ?? buttonProps?.onClick}
      sx={{
        width: '100%',
        minHeight: authScreen.controlHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        py: 1.15,
        px: 1.75,
        borderRadius: marketing ? '999px' : authScreen.pillRadius,
        border: marketing ? '1px solid var(--l-line-strong)' : `1px solid ${authScreen.glassBorder}`,
        bgcolor: marketing ? 'transparent' : authScreen.bgElevated,
        color: marketing ? 'var(--l-ink)' : authScreen.text,
        cursor: mergedDisabled ? 'not-allowed' : 'pointer',
        opacity: mergedDisabled ? 0.5 : 1,
        fontFamily: marketing ? 'var(--l-font)' : authScreen.font,
        transition: 'background-color 0.2s ease, border-color 0.2s ease, transform 0.15s ease',
        '&:hover': mergedDisabled
          ? undefined
          : marketing
            ? { bgcolor: 'var(--l-hover)', borderColor: 'var(--l-ink-3)' }
            : {
                bgcolor: 'rgba(255,255,255,0.08)',
                borderColor: authScreen.border,
              },
        '&:active': mergedDisabled ? undefined : { transform: 'scale(0.98)' },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', width: 20, justifyContent: 'center' }}>{icon}</Box>
      <Typography component="span" sx={{ fontWeight: 500, fontSize: '0.875rem', letterSpacing: '-0.01em' }}>
        {children}
      </Typography>
    </Box>
  );
}
